const getFees = response => response?.fees || []

const getBonuses = response => response?.bonuses || []

const buildAmountsByLabel = items => {
  const itemsWithAmount = items.filter(({ label, amount }) => label && Number(amount) > 0)
  return Object.fromEntries(itemsWithAmount.map(({ label, amount }) => [label, Number(amount)]))
}

export const getPreviewFees = response => buildAmountsByLabel(getFees(response))

export const getPreviewBonuses = response => buildAmountsByLabel(getBonuses(response))

export const getPreviewFeeMessages = response => {
  return getFees(response)
    .filter(fee => fee.message)
    .map(fee => ({ label: fee.label, message: fee.message, message_type: fee.message_type }))
}
